<template>
  <div class="passenger-item" :class="passenger.sex">
    <div class="names">{{ passenger.given_names }} {{ passenger.surname }}</div>
    <div class="dob">{{ passenger.dob }}</div>
    <div class="sex" :class="[passenger.sex ? passenger.sex : '']">
      <icon :name="passenger.sex" class="" width="32" height="32" />
    </div>
    <div class="passport">
      <div v-if="passenger.nationality" class="nationality">{{ getCountry(passenger.nationality)[0].name }}</div>
      <div v-if="passenger.passport_number" class="passport-number">{{ passenger.passport_number }}</div>

      <div class="dates">
        <div v-if="passenger.passport_issue" class="passport-issue">
          <div class="date">{{ $filters.setFormatDate(passenger.passport_issue, 'DD-MM-YYYY') }}</div>
          <div class="label">Issue</div>
        </div>

        <div v-if="passenger.passport_expire" class="passport-expire" :class="passengerClasses(passenger)">
          <div class="date">{{ $filters.setFormatDate(passenger.passport_expire, 'DD-MM-YYYY') }}</div>
          <div class="label">Expire</div>
        </div>
      </div>
    </div>

    <div class="actions">
      <EditPassengerModal :passenger="passenger" :passengers="passengers" :form="form" :customers="customers" />
      <button class="btn btn-outline-danger" type="button" @click="removePassenger(index)">Delete</button>
    </div>
  </div>
</template>

<script>
import EditPassengerModal from './EditPassengerModal'
import Icon from '@/Shared/Icon'
import Country from '@/Shared/Country.js'

export default {
  name: 'PassengerCard',
  components: {
    EditPassengerModal,
    Icon,
    Country
  },
  props: ['form', 'passenger', 'passengers', 'customers', 'index'],
  data() {
    return {
      countries: Country
    }
  },
  methods: {
    removePassenger(index) {
      this.form.passengers.splice(index, 1);
    },
    passengerClasses(passenger) {
      return {
        active: this.form.passengers.some(pass => pass['passport_number'] === passenger.passport_number),
        expired: Date.parse(passenger.passport_expire) - Date.parse(new Date()) < 0
      }
    },
    getCountry(country) {
      return this.countries.filter(c => c.code == country)
    }
  }
}
</script>

<style>

</style>
